import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { Group, ActionIcon, TextInput, Text, Button, Loader, Tooltip } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

import FilterSelectionPanel from "./FilterSelectionPanel";

import { setTiptapSidemenu } from "../../../../store/app";

export default function FilterPanelController({
  type,
  filters,
  filtersSelected,
  sortSelected,
  loading,
  theme,
  term,
  setTerm,
  onSelectFilter,
  onUpdateFilter,
  onUpdateSort,
  RightComponent
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [isSearching, setIsSearching] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [isSortVisible, setIsSortVisible] = useState(false);

  const onPressSettings = () => {
    dispatch(setTiptapSidemenu({ opened: type, option: window.$fetchedTopSlug }));
  };

  const onKeyDown = (event) => {
    if (event.which == 13) {
      event.preventDefault();
      onSearch();
    }
  };

  const onSearch = () => {
    if (typeof setTerm === "function") {
      setTerm(document.getElementById("search-input").value);
    }
  };

  const onClearSearch = () => {
    document.getElementById("search-input").value = "";
    if (typeof setTerm === "function") {
      setTerm("");
    }
  };

  const toggleFilter = () => {
    setIsFilterVisible((prev) => !prev);
    if (isSortVisible) setIsSortVisible(false);
  };

  const toggleSort = () => {
    setIsSortVisible((prev) => !prev);
    setIsFilterVisible(!(isFilterVisible && isSortVisible));
  };

  return (
    <>
      <Group position="apart" mt={20}>
        {isSearching ? (
          <Group position="left" spacing="xs">
            <ActionIcon onClick={() => setIsSearching(false)}>
              <FontAwesomeIcon icon={solid("xmark")} />
            </ActionIcon>
            <TextInput
              sx={{ width: "200px" }}
              icon={<FontAwesomeIcon icon={solid("search")} />}
              placeholder={t("spaces.settings.members.registered.registered.searchPlaceholder")}
              id="search-input"
              radius="xl"
              onKeyDown={(event) => onKeyDown(event)}
              rightSection={
                term ? (
                  <Text
                    sx={{ cursor: "pointer" }}
                    onClick={() => onClearSearch()}
                  >
                    <FontAwesomeIcon icon={solid("xmark")} />
                  </Text>
                ) : (
                  <Text>{"  "}</Text>
                )
              }
            />
            <Button
              variant="filled"
              radius="xl"
              onClick={() => onSearch()}
              sx={{
                backgroundColor: theme.colors.sutrablue[3],
                "&:hover": {
                  backgroundColor: theme.colors.sutrablue[4],
                }
              }}
            >
              {t("spaces.settings.members.registered.registered.searchButton")}
            </Button>
            {loading && <Loader size="xs" />}
          </Group>
        ) : (
          <Group spacing={0} pb={8}>
            <Tooltip label="Filter">
              <ActionIcon onClick={toggleFilter}>
                <FontAwesomeIcon icon={solid("sliders")} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Sort">
              <ActionIcon onClick={toggleSort}>
                <FontAwesomeIcon icon={solid("sort")} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Search">
              <ActionIcon onClick={() => setIsSearching(true)}>
                <FontAwesomeIcon icon={solid("search")} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Settings">
              <ActionIcon onClick={onPressSettings}>
                <FontAwesomeIcon icon={solid("cog")} />
              </ActionIcon>
            </Tooltip>
          </Group>
        )}

        {!!RightComponent && <RightComponent />}

      </Group>

      {isFilterVisible && (
        <FilterSelectionPanel
          filters={filters}
          filtersSelected={filtersSelected}
          isSortVisible={isSortVisible}
          sortSelected={sortSelected}
          onSelectFilter={onSelectFilter}
          onUpdateFilter={onUpdateFilter}
          onUpdateSort={onUpdateSort}
          onPressCreateFilter={onPressSettings}
        />
      )}

    </>
  );
}